export default __webpack_public_path__ + "static/media/card3.69397bff.jpg";